
export const SIGNOUT = "SIGNOUT";
export const SIGNIN = "SIGNIN";
export const SIGNIN_FAILED = "SIGNIN_FAILED";
export const INITIALIZING_AUTH = "INITIALIZING_AUTH";